import { createFileRoute } from "@tanstack/react-router";

import { trpc } from "@lib/api/client";
import { PhotoUploadView } from "@pages/photos/photo-upload-view";

export const Route = createFileRoute("/_auth/photos/new")({
  component: PhotoUploadView,
  loader: ({ context }) => context.queryClient.ensureQueryData(trpc.sessions.list.queryOptions()),
});
